import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {SelectFilterElement} from '../../../../../../components/common/select-filter/select-filter.model';

@Component({
  selector: 'app-document-formats-select-filter',
  templateUrl: './document-formats-select-filter.component.html'
})
export class DocumentFormatsSelectFilterComponent implements OnInit {

  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;

  formats: BehaviorSubject<SelectFilterElement<string, string>[]> = new BehaviorSubject<SelectFilterElement<string, string>[]>([]);


  ngOnInit() {
    const values = ['EXCEL', 'IMAGE', 'PDF', 'STL', 'WORD', 'OPENOFFICE'];
    this.formats.next(values.map(value => new SelectFilterElement(value, value, value)));
  }

  filterFormats = (criteria: string, format: string) => {
    return format.toUpperCase().startsWith(criteria.toUpperCase());
  }

}
